import { Pullout, PulloutType } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import styled from 'styled-components';
import ContentConstants from '../../contentConstants';
import { SurveyStep } from '../../models';
import { DisplayLogicConditionError } from '../../models/displayLogic/DisplayLogicConditionError';
import { ClearDiv } from '../common';

const LinkToStep = styled.span`
	cursor: pointer;
	text-decoration: underline;
`;
LinkToStep.displayName = 'LinkToStep';

const ErrorMessageContainer = styled.div`
	width: 50%;
	margin-left: auto;
	margin-right: auto;
`;

export interface IDisplayLogicConditionErrorMessageProps {
	errorCondition?: DisplayLogicConditionError;
	Jump: (destinationStep: SurveyStep) => void;
	ResetQuestionDisplayLogic: () => void;
}

export class DisplayLogicConditionErrorMessage extends React.Component<IDisplayLogicConditionErrorMessageProps> {
	public render() {
		return <div>{this.getErrorCondition()}</div>;
	}

	private getErrorCondition() {
		if (this.props.errorCondition !== undefined) {
			let msg1 = '';
			let msg2 = '';
			let msg3 = '';
			let step;
			switch (this.props.errorCondition) {
				case DisplayLogicConditionError.NoSourceSelected:
					msg1 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_NO_SOURCE_PART1;
					msg2 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_NO_SOURCE_PART2;
					msg3 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_NO_SOURCE_PART3;
					step = SurveyStep.Basics;
					break;
				case DisplayLogicConditionError.HasOtherSourceAndSingleLinkSelection:
					msg1 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART1;
					msg2 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART2;
					msg3 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_SOURCE_NO_DIST_PART3;
					step = SurveyStep.Distribution;
					break;
				case DisplayLogicConditionError.HasHierarchySourceAndAttributeSelection:
				case DisplayLogicConditionError.HasOtherSourceAndHierarchySelection:
					msg1 = ContentConstants.DISPLAY_LOGIC_CONDITION_ERROR_OTHER_SOURCE;
					step = SurveyStep.Distribution;
					break;
			}
			return this.displayErrorCondition(msg1, msg2, msg3, step);
		}
	}

	private displayErrorCondition(msg1: string, msg2: string, msg3: string, step: SurveyStep) {
		return (
			<ErrorMessageContainer>
				<ClearDiv />
				<Pullout type={PulloutType.Warning}>
					<strong>{ContentConstants.NOT_AVAILABLE}</strong>
					{msg1}
					<LinkToStep
						onClick={() => {
							this.props.ResetQuestionDisplayLogic();
							this.props.Jump(step);
						}}
					>
						{msg2}
					</LinkToStep>
					{msg3}
				</Pullout>
			</ErrorMessageContainer>
		);
	}
}
